import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationWrite, ParcelAppEntityParcelWrite } from '../../../../../../openapi';

@Injectable()
export class IrspaDetailedInformationOnTheLetterContentForm extends AppForm {
  constructor() {
    super({
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: []
        }
      )
    });
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    let value = this.value;
    delete value.parcels;
    return value;
  }
}
